var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14.4,
    height: 14.374,
    viewBox: "0 0 14.4 14.374",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3526",
    "data-name": "Rectangle 3526",
    width: 14.4,
    height: 14.374,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10438",
    "data-name": "Group 10438",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10427",
    "data-name": "Group 10427",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27751",
    "data-name": "Path 27751",
    d: "M10.782,9.546a1.434,1.434,0,0,0-2.036,0l-.693.693a12.538,12.538,0,0,1-2.16-1.734A12.887,12.887,0,0,1,4.16,6.346l.693-.693a1.434,1.434,0,0,0,0-2.036L3.5,2.265a1.4,1.4,0,0,0-1.01-.421,1.446,1.446,0,0,0-1.02.421l-.651.646A3.052,3.052,0,0,0,.031,5.425,10.155,10.155,0,0,0,3.177,11.2a10.319,10.319,0,0,0,5.8,3.165,3.511,3.511,0,0,0,.4,0,2.909,2.909,0,0,0,2.112-.785l.646-.651a1.446,1.446,0,0,0,.421-1.02,1.4,1.4,0,0,0-.421-1.01Zm.676,2.709-.651.646a2.186,2.186,0,0,1-1.754.479,9.287,9.287,0,0,1-5.176-2.874A9.394,9.394,0,0,1,.989,5.345a2.168,2.168,0,0,1,.479-1.754l.676-.651a.483.483,0,0,1,.678,0L4.179,4.31a.482.482,0,0,1,0,.676l-.958.958a.476.476,0,0,0-.077.579A13.121,13.121,0,0,0,5.217,9.194,13.135,13.135,0,0,0,7.891,11.27a.479.479,0,0,0,.579-.077l.958-.958a.481.481,0,0,1,.676,0l1.355,1.354a.492.492,0,0,1,.139.342.471.471,0,0,1-.139.324M12.291,2.1A7.138,7.138,0,0,0,7.215,0a.479.479,0,1,0,0,.958,6.23,6.23,0,0,1,6.226,6.278.479.479,0,0,0,.958,0A7.139,7.139,0,0,0,12.291,2.1",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27752",
    "data-name": "Path 27752",
    d: "M13.565,6.554a2.886,2.886,0,0,1,.848,2.065.479.479,0,1,0,.958,0A3.833,3.833,0,0,0,11.54,4.738a.479.479,0,0,0,0,.958,2.884,2.884,0,0,1,2.026.858",
    transform: "translate(-3.998 -1.712)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIcon);
export default __webpack_public_path__ + "static/media/call-icon.29d0c338edcebd53a3d16d8fbdc86dcd.svg";
export { ForwardRef as ReactComponent };